/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import { ref } from 'vue';

const useEnvironmentHandlerStore = defineStore('environmentHandler', () => {
  const dc = ref<string>('');
  const states = ref<Record<string, any>>([]);

  const setDc = (newDc: string): void => {
    dc.value = newDc;
  };

  const getDc = (): string => dc.value;

  // eslint-disable-next-line no-return-assign
  const setState = (state: string, value: any): void => states.value[state] = value;

  const getState = (state: string): any => states.value[state];

  return {
    setDc,
    getDc,
    setState,
    getState,
  };
});

export {
  useEnvironmentHandlerStore,
};
